import { Button } from '@1trading/react/components/ui/button';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { Input } from '@1trading/react/components/ui/input';
import { Plus, Trash2 } from 'lucide-react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { InstitutionBusinessProfileOrDefaults } from '@/features/institution/business-profile/schema';

const TOP_EXCHANGES_MAX = 5;

const InstitutionBusinessProfileFieldsetTopExchanges = () => {
  const form = useFormContext<InstitutionBusinessProfileOrDefaults>();
  const { fields, append, remove } = useFieldArray({ control: form.control, name: 'topExchanges' });
  const { t } = useTranslation();

  return (
    <fieldset className="space-y-4">
      <legend className="font-medium">{t('institutionDetails.businessProfile.topExchanges.title')}</legend>
      <p className="text-sm text-muted-foreground">{t('institutionDetails.businessProfile.topExchanges.description')}</p>
      {fields.map((exchange, index) => (
        <FormField
          key={exchange.id}
          control={form.control}
          name={`topExchanges.${index}.name`}
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t('institutionDetails.businessProfile.topExchanges.exchange')} {index + 1}
              </FormLabel>
              <div className="flex gap-2">
                <FormControl>
                  <Input {...field} placeholder={t('institutionDetails.businessProfile.placeholders.topExchange')} />
                </FormControl>
                <Button className="shrink-0 text-destructive hover:text-destructive" size="icon" type="button" variant="ghost" onClick={() => remove(index)}>
                  <Trash2 className="size-4" />
                  <span className="sr-only">
                    {t('institutionDetails.businessProfile.topExchanges.remove')} {index + 1}
                  </span>
                </Button>
              </div>
              <FormMessage />
            </FormItem>
          )}
        />
      ))}
      {fields.length < TOP_EXCHANGES_MAX ? (
        <Button className="gap-2" size="sm" type="button" variant="outline" onClick={() => append({ name: '' })}>
          <Plus className="size-4" />
          {t('institutionDetails.businessProfile.topExchanges.add')}
        </Button>
      ) : null}
    </fieldset>
  );
};
InstitutionBusinessProfileFieldsetTopExchanges.displayName = 'InstitutionBusinessProfileFieldsetTopExchanges';

export { InstitutionBusinessProfileFieldsetTopExchanges };
